import { endPoints } from 'api/';
import { getStorages } from 'actions/storages/';
import { DELETE_STORAGE, UPDATE_STORAGE } from 'actions/types';

/**
  @description Updates storage object. This will also act as `delete` action by `disabling` status.
  @param {string} storageId
  @param {FormData} payload
  @param {string} companyId Current user's company id.
  @param {boolean} isDeleting If set to true, it will still update the record but UI status will be delete
  @returns Storage object
 */
function updateStorage(storageId, payload, companyId, isDeleting = false) {
  const actionType = isDeleting ? DELETE_STORAGE : UPDATE_STORAGE;

  /**
    @param {Function} dispatch
   */
  return (dispatch) => {
    const action = {
      type: actionType,
      /**
        @param {Function} apiClient
       */
      request: async (apiClient) => {
        const storage = await apiClient(
          endPoints.UPDATE_STORAGE,
          payload,
          storageId,
        );

        dispatch(getStorages({ companyId }));

        return storage;
      },
    };

    dispatch(action);
  };
}

export default updateStorage;
